<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Users</h3>
            </div>
            <div class="col-6 text-right">
                <router-link :to="{name: 'addgames'}" class="button primary">Add Games</router-link>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="20" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="gTypeStatus" slot-scope="props">
                    <div :class="props.rowData.gTypeStatus | gamesClassStatus"><strong>{{props.rowData.gTypeStatus | gamesStatus}}</strong></div>
                </div>
                <div slot="gTypeId" slot-scope="props">
                    <strong>{{props.rowData.gTypeId | gameCategoryID}}</strong>
                </div>
    
                <div slot="gPriority" slot-scope="props">
                    <strong :class="{'text-green':props.rowData.gPriority== 15,'text-red': props.rowData.gPriority!= 15}">{{props.rowData.gPriority | gamesVisible}}</strong>
                </div>
                <div slot="action" slot-scope="props">
                    <button class="button primary" id="editGame" @click="showModal(props.rowData)"><i class="fas fa-edit"></i></button>
                </div>
            </vuetable>
    
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
    
        </div>
        <b-modal ref="editGameModal" hide-footer :title="'Edit Games - '+selectedGame.gName">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-6">
                    <label>Game Name</label>
                    <input type="text" v-model="selectedGame.gName" placeholder="Enter Game">
                </div>
                <div class="col-6">
                    <label>Game Code</label>
                    <input type="text" v-model="selectedGame.gCode" placeholder="Enter Game Code">
                </div>
    
                <div class="col-6">
                    <label>Game Priority (1 - 15)</label>
                    <input type="number" v-model="selectedGame.gPriority" min="1" max="15">
                </div>
                <div class="col-6">
                    <label>Select Game Status</label>
                    <select v-model="selectedGame.gTypeStatus">
                            <option value>Select Game Type</option>
                            <option value="1">Active</option>
                            <option value="2">Hidden</option>
                        </select>
                </div>
                <div class="col-12">
                    <label>Image URL</label>
                    <input type="url" v-model="selectedGame.gUrl" placeholder="Enter Image URL">
                </div>
    
            </div>
    
            <div class="mb-3">
                <b-button variant="outline-success" block @click="editGame()">Edit Game</b-button>
            </div>
    
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",
    data() {
        return {
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/display/v1/game/dash",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [{
                    name: "gName",
                    title: '<span class="orange glyphicon glyphicon-user"></span> Game Name',
                    sortField: "gName",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "gCode",
                    title: "Game Code",
                    sortField: "gCode",
                    titleClass: "",
                    dataClass: ""
                },

                {
                    name: "gPartner",
                    title: "Provider",
                    sortField: "gPartner",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "gTypeStatus",
                    title: "Status",
                    sortField: "gTypeStatus",
                },
                {
                    name: "gPriority",
                    title: "Visible",
                    sortField: "gPriority",
                },
                {
                    name: "gTypeId",
                    title: "Category",
                    sortField: "gTypeId",
                },
                {
                    name: "action",
                    title: "Action"

                }

            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "gId",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            },
            selectedGame: {
                gCode: "",
                gId: "",
                gLite: "",
                gName: "",
                gPartner: "",
                gPriority: "",
                gProviderState: "",
                gProviderUrl: "",
                gState: "",
                gType: "",
                gTypeId: "",
                gTypeStatus: "",
                gUrl: ""
            },
            errorcreateStatus: false,
            errorsMessage: ""
        };
    },

    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }

        var start = moment().subtract(120, "days");
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
            $('input[name="dates"]').val(
                start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
            );
        }

        $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days")
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [
                        moment()
                        .subtract(1, "month")
                        .startOf("month"),
                        moment()
                        .subtract(1, "month")
                        .endOf("month")
                    ]
                }
            },
            cb
        );

        cb(start, end);
    },

    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },

    methods: {
        showModal(val) {
            this.selectedGame = val
            this.$refs['editGameModal'].show()
        },
        hideModal() {
            this.$refs['editGameModal'].hide()
        },
        editGame() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'portal/v1/game/edit',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    gameName: vm.selectedGame.gName,
                    gameStatus: vm.selectedGame.gTypeStatus,
                    gamePriority: vm.selectedGame.gPriority,
                    gameId: vm.selectedGame.gId,
                    gameImageUrl: vm.selectedGame.gProviderUrl,
                    gameCode: vm.selectedGame.gCode,
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createUser").text("Create Game");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createUser").text("Create Game");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },

        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },

        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        }
    },
    filters: {
        gamesVisible(value) {
            if (value == 15) {
                return "Yes"
            } else {
                return "Hidden"
            }
        },
        gamesStatus(value) {
            if (value == 1) {
                return "Active"
            } else {
                return "Disabled"
            }
        },
        gamesClassStatus(value) {
            if (value == '1') {
                return "green"
            } else {
                return "red"
            }
        },
        gameCategoryID(value) {
            if (value == 1) {
                return "Slot"
            } else if (value == 2) {
                return "Table"
            } else if (value == 3) {
                return "Virtuals"
            } else if (value == 4) {
                return "Live"
            } else if (value == 5) {
                return "Hot"
            } else {
                return "Most Popular"
            }
        },
    }
};
</script>
